import {
  Typography,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Table,
  Tooltip,
} from "@mui/material";
import { capitalizeWords } from "../../../../utils/functions";
import {
  BODY_SPACING,
  TEXT_FEATURES,
  COMPONENT_SPACING,
} from "../../../../utils/constants/designConstants";

const TABLE_HEADERS = [
  "Supplier Name",
  "Description",
  "Category L1",
  "Category L2",
  "Category L3",
];

export const ExistingSuppliersTable = ({ existingSuppliers }) => {
  if (!existingSuppliers || existingSuppliers.length === 0) {
    return (
      <Typography
        variant="body2"
        sx={{
          color: "primary.white",
          py: BODY_SPACING.ERROR_MESSAGE_SECTION_PADDING,
          mb: BODY_SPACING.ERROR_MESSAGE_SECTION_MARGIN_BOTTOM,
        }}
      >
        Existing suppliers aren't available at the moment.
      </Typography>
    );
  }
  try {
    return (
      <TableContainer component={Paper} variant="outlined">
        <Table
          sx={{ minWidth: COMPONENT_SPACING.MIN_TABLE_WIDTH }}
          stickyHeader
          aria-label="existing suppliers table"
          size="small"
        >
          <TableHead>
            <TableRow>
              {TABLE_HEADERS.map((header, index) => (
                <TableCell key={index}>{header}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {existingSuppliers.map((item, index) => (
              <TableRow key={index} hover>
                {/* Supplier Name */}
                <TableCell>{item["Supplier Name"] || "-"}</TableCell>
                {/* Description */}
                <TableCell
                  sx={{
                    minWidth: COMPONENT_SPACING.MIN_CELL_WIDTH,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  <Tooltip title={item.Description || "-"} arrow>
                    <span
                      style={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        display: "inline-block",
                        maxWidth: "100%",
                      }}
                    >
                      {item.Description.length >
                      TEXT_FEATURES.MAX_DESCRIPTION_LEN_LONG
                        ? item.Description.slice(
                            0,
                            TEXT_FEATURES.MAX_DESCRIPTION_LEN_LONG,
                          ) + "..."
                        : item.Description || "-"}
                    </span>
                  </Tooltip>
                </TableCell>
                {/* Category L1 */}
                <TableCell>
                  {item["Category L1"]
                    ? capitalizeWords(item["Category L1"])
                    : "-"}
                </TableCell>
                {/* Category L2 */}
                <TableCell sx={{ whiteSpace: "normal" }}>
                  {item["Category L2"]
                    ? capitalizeWords(item["Category L2"])
                    : "-"}
                </TableCell>
                {/* Category L3 */}
                <TableCell sx={{ whiteSpace: "normal" }}>
                  {item["Category L3"]
                    ? capitalizeWords(item["Category L3"])
                    : "-"}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  } catch (error) {
    console.error("Error rendering existing suppliers table:", error);
    return (
      <Typography
        variant="body2"
        color="error"
        sx={{ py: BODY_SPACING.ERROR_MESSAGE_SECTION_PADDING }}
      >
        Sorry, we couldn’t display existing suppliers at the moment.
      </Typography>
    );
  }
};
